import { render } from "./vue-modal.vue?vue&type=template&id=7f0fb133"
import script from "./vue-modal.vue?vue&type=script&lang=js"
export * from "./vue-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__